var _rect, _text, _rect2, _circle, _path, _text2, _text3, _text4, _rect3, _circle2, _circle3, _circle4, _path2, _text5, _text6, _text7, _rect4, _circle5, _circle6, _path3, _text8, _text9, _text0, _rect5, _circle7, _path4, _path5, _text1, _text10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportFinalDemonstrationOneSiteScopeDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 430,
    viewBox: "0 0 1200 430",
    role: "img",
    "aria-label": "Work Passport demonstration scope desktop card",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 430,
    rx: 38,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 60,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "MAP A PRACTICAL FIRST SCOPE")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 98,
    width: 338,
    height: 176,
    rx: 25,
    fill: "#07152A",
    stroke: "#29405D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 151,
    r: 30,
    fill: "#087CFF",
    fillOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.92 160.36v-19.439999999999998h20.16v19.439999999999998M97.96 145.96h2.16m3.5999999999999996 0h2.16m3.5999999999999996 0h2.16M90.76 160.36h24.48",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 149,
    y: 137,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 149,
    y: 169,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 21,
    fontWeight: 850
  }, "One site")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 230,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Deployment environment")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 98,
    width: 338,
    height: 176,
    rx: 25,
    fill: "#07152A",
    stroke: "#29405D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 151,
    r: 30,
    fill: "#F54291",
    fillOpacity: 0.13
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.96,
    cy: 145.96,
    r: 3.5999999999999996,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.76,
    cy: 146.68,
    r: 2.88,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465.48 160.36c0-5.76 12.959999999999999-5.76 12.959999999999999 0M479.16 159.64c0-4.32 10.08-4.32 10.08 0",
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 523,
    y: 137,
    fill: "#F54291",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 523,
    y: 169,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 21,
    fontWeight: 850
  }, "One workforce segment")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 230,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Relevant employee group")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 796,
    y: 98,
    width: 338,
    height: 176,
    rx: 25,
    fill: "#07152A",
    stroke: "#29405D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 851,
    cy: 151,
    r: 30,
    fill: "#30D6A1",
    fillOpacity: 0.13
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 851,
    cy: 144.52,
    r: 4.32,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M841.64 161.08c0-8.64 18.72-8.64 18.72 0",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 897,
    y: 137,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 897,
    y: 169,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 21,
    fontWeight: 850
  }, "One role family")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 230,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Requirements for the work")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 320,
    width: 700,
    height: 68,
    rx: 20,
    fill: "#10243E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 354,
    r: 24,
    fill: "#30D6A1",
    fillOpacity: 0.14
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M292 344.4l8.4 3v6c0 5.3999999999999995-3.5999999999999996 9-8.4 11.4-8.4-2.4-8.4-6-8.4-11.4v-6z",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.8 354l3 3 6-6.6",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 334,
    y: 344,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "DEMONSTRATION RESULT")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 334,
    y: 371,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 17,
    fontWeight: 850
  }, "A live readiness model your team can interrogate")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportFinalDemonstrationOneSiteScopeDesktop);
export default __webpack_public_path__ + "static/media/work-passport-final-demonstration-one-site-scope-desktop.d9d6b6cefa9829535868d52b8c92e1af.svg";
export { ForwardRef as ReactComponent };